interface ValidProps {
  validationSize: (
    event: { file: File }[],
    fileSize: number,
    type: string,
  ) => boolean;
}

export default function ValidationFileSize(): ValidProps {
  function validationSize(
    event: { file: File }[],
    fileSize: number,
    type: string,
  ) {
    const doc = event[0]?.file as File;
    let docSize = 0;
    if (type.toUpperCase() === 'KB') {
      docSize = doc.size / 1024;
    } else if (type.toUpperCase() === 'MB') {
      docSize = doc.size / 1048576;
    } else if (type.toUpperCase() === 'GB') {
      docSize = doc.size / 1073741824;
    } else {
      return false;
    }

    if (docSize >= fileSize) return false;
    return true;
  }
  return {
    validationSize,
  };
}
